var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34C0 34.5523 0.447714 35 0.999999 35H39C39.5523 35 40 34.5523 40 34V6C40 5.44772 39.5523 5 39 5H1C0.447715 5 0 5.44772 0 6V34ZM4 12V31H36V12H4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23.8992C6 21.4139 8.01472 19.3992 10.5 19.3992C12.9853 19.3992 15 21.4139 15 23.8992V24.2592H6V23.8992Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7657 16.3101C12.7657 17.5859 11.7314 18.6201 10.4556 18.6201C9.17978 18.6201 8.14553 17.5859 8.14553 16.3101C8.14553 15.0343 9.17978 14 10.4556 14C11.7314 14 12.7657 15.0343 12.7657 16.3101Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28C5 27.4477 5.44772 27 6 27H15C15.5523 27 16 27.4477 16 28C16 28.5523 15.5523 29 15 29H6C5.44771 29 5 28.5523 5 28Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28C17 27.4477 17.4477 27 18 27H22C22.5523 27 23 27.4477 23 28C23 28.5523 22.5523 29 22 29H18C17.4477 29 17 28.5523 17 28Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C24 27.4477 24.4477 27 25 27H29C29.5523 27 30 27.4477 30 28C30 28.5523 29.5523 29 29 29H25C24.4477 29 24 28.5523 24 28Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28C31 27.4477 31.4477 27 32 27H34C34.5523 27 35 27.4477 35 28C35 28.5523 34.5523 29 34 29H32C31.4477 29 31 28.5523 31 28Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15C19 14.4477 19.4477 14 20 14H29C29.5523 14 30 14.4477 30 15C30 15.5523 29.5523 16 29 16H20C19.4477 16 19 15.5523 19 15Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19C19 18.4477 19.4477 18 20 18H29C29.5523 18 30 18.4477 30 19C30 19.5523 29.5523 20 29 20H20C19.4477 20 19 19.5523 19 19Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23C19 22.4477 19.4477 22 20 22H29C29.5523 22 30 22.4477 30 23C30 23.5523 29.5523 24 29 24H20C19.4477 24 19 23.5523 19 23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCni);
export default __webpack_public_path__ + "static/media/icon_CNI.dd073493a49b41099d4cf12248e99633.svg";
export { ForwardRef as ReactComponent };